import script from "./packages.vue?vue&type=script&setup=true&lang=js"
export * from "./packages.vue?vue&type=script&setup=true&lang=js"

import "./packages.vue?vue&type=style&index=0&id=7cb64f46&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7cb64f46"]])

export default __exports__